var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 227 219",
    style: {
      enableBackground: "new 0 0 227 219"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{opacity:0.67;fill:url(#SVGID_3_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{opacity:0.67;fill:url(#SVGID_11_);enable-background:new    ;}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{opacity:0.67;fill:url(#SVGID_19_);enable-background:new    ;}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.5155,
    y1: 153.5145,
    x2: 192.0755,
    y2: 187.6612,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.2,37.5c0,0-8.7-0.8-15.4,18.6c-2.8,7.9-6.4,15.5-10.3,22.1c-9.7,5.7-18.4,2-25.2-3.9 c3.1-0.8,7.1-2.3,11.5-4.9c9.3-5.5,14.9-20.3,21.9-28.5C181.6,32.8,191.9,37.4,192.2,37.5C192.2,37.5,192.2,37.5,192.2,37.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.9995,
    y1: 154.4579,
    x2: 220.2505,
    y2: 212.3033,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.2,37.5c-0.3-0.2-10.6-4.7-17.5,3.4c-7,8.2-12.7,23-21.9,28.5c-4.3,2.6-8.4,4.1-11.5,4.9 c-5-4.4-8.9-10-11.2-13.7c10.6,7.1,16.8,1.3,25.2-11.9C165.9,32.1,176.8,23.6,192.2,37.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.9995,
    y1: 154.4579,
    x2: 220.2505,
    y2: 212.3033,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    style: {
      stopColor: "#F9FCFE",
      stopOpacity: 0.2444
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#E8F3FB",
      stopOpacity: 0.6141
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#CFE6F6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.2,37.5c-0.3-0.2-10.6-4.7-17.5,3.4c-7,8.2-12.7,23-21.9,28.5c-4.3,2.6-8.4,4.1-11.5,4.9 c-5-4.4-8.9-10-11.2-13.7c10.6,7.1,16.8,1.3,25.2-11.9C165.9,32.1,176.8,23.6,192.2,37.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3114,
    y1: 151.4122,
    x2: 173.3961,
    y2: 163.2616,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#202A4F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.5,78.2c-5.7,9.6-12.1,17.3-17.7,21.1c-6.2,4.2-19.9,13.6-38-11.7C93,62.6,56.7,28.4,33.6,66.5 c0,0,0,0,0-0.1c0-2.2,0.3-36.2,30.1-41.7c19.1-3.8,40.3,9.7,57.1,27.6c3.5,3.7,6.6,6.5,9.4,8.3c2.3,3.7,6.2,9.3,11.2,13.7 C148.1,80.2,156.8,84,166.5,78.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: -156.5272,
    cy: 506.8101,
    r: 0.9999,
    gradientTransform: "matrix(12.9155 0 0 -12.9155 2185.438 6600.8921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153,69.7l-0.3-0.5c5.8-3.5,10.2-10.7,14.5-17.6c2.5-4,4.8-7.9,7.4-10.9l0.4,0.4c-2.5,3-4.8,6.8-7.3,10.8 C163.3,58.9,158.9,66.1,153,69.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1358,
    y1: 205.4096,
    x2: 192.9662,
    y2: 72.773,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A56A3"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.6,66.4c0,0,3.4-21.4,13.1-30.7c8.7-8.3,27.2-21.5,51,0.4c22.8,21,37.2,53.1,58.6,47.8 c0,0-14.5,17.3-28.7,1.1c-14.1-16.2-32-39.8-48-45.7C63.6,33.3,40.3,46.9,33.6,66.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: -162.6326,
    cy: 517.7222,
    r: 0.9999,
    gradientTransform: "matrix(23.6184 0 0 -23.6184 3944.7937 12289.9492)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.6,85.1c-1.9-2.1-3.7-4.2-5.6-6.3l-5.5-6.3c-3.7-4.2-7.3-8.4-11.1-12.5c-3.8-4.1-7.7-8-11.9-11.6L92,47 c-0.5-0.4-1.1-0.8-1.6-1.3l-1.7-1.3l-1.7-1.2c-2.3-1.6-4.8-2.9-7.3-4c5.2,1.9,9.9,5.2,14.2,8.7c4.3,3.6,8.3,7.5,12.1,11.6 c3.8,4.1,7.5,8.3,11,12.6L127.6,85.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: -160.8952,
    cy: 514.6173,
    r: 0.9999,
    gradientTransform: "matrix(19.1119 0 0 -19.1119 3209.783 9857.4238)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D41216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1965,
    style: {
      stopColor: "#D11217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#C71418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5002,
    style: {
      stopColor: "#B8161A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6375,
    style: {
      stopColor: "#A3171B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7694,
    style: {
      stopColor: "#8A171B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    style: {
      stopColor: "#6D1518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#511014"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.8,41.2c10.6,0,19.1-8.6,19.1-19.1c0-10.6-8.6-19.1-19.1-19.1s-19.1,8.6-19.1,19.1 C115.7,32.7,124.2,41.2,134.8,41.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.6235,
    y1: 48.3991,
    x2: 140.8725,
    y2: 5.2221,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M136.3,212c0,0,5.2-6.9-7.6-22.9c-5.2-6.5-9.7-13.6-13.3-20.5c0.3-11.2,8.1-16.7,16.7-19.3 c-0.9,3.1-1.8,7.3-1.9,12.3c-0.2,10.8,9.3,23.4,12.6,33.7C146,205.5,136.6,211.8,136.3,212C136.3,212,136.3,212,136.3,212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.8469,
    y1: 66.1286,
    x2: 146.8039,
    y2: -31.7404,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.3,212c0.3-0.2,9.7-6.5,6.4-16.6c-3.3-10.3-12.8-22.9-12.6-33.7c0.1-5.1,1-9.3,1.9-12.3 c6.4-1.9,13.2-2.3,17.6-2.2c-11.6,5.2-10,13.5-3.3,27.7C154.9,192.6,156.3,206.3,136.3,212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.8469,
    y1: 66.1286,
    x2: 146.8039,
    y2: -31.7404,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    style: {
      stopColor: "#F9FCFE",
      stopOpacity: 0.2444
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#E8F3FB",
      stopOpacity: 0.6141
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#CFE6F6"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M136.3,212c0.3-0.2,9.7-6.5,6.4-16.6c-3.3-10.3-12.8-22.9-12.6-33.7c0.1-5.1,1-9.3,1.9-12.3 c6.4-1.9,13.2-2.3,17.6-2.2c-11.6,5.2-10,13.5-3.3,27.7C154.9,192.6,156.3,206.3,136.3,212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.5074,
    y1: 133.5699,
    x2: 130.1163,
    y2: 33.983,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#202A4F"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M115.4,168.6c-5.1-10-8.2-19.5-8.5-26.2c-0.3-7.4-1-24.1,30.1-26c30.6-1.8,78.9-14.5,58.9-54.2 c0,0,0,0,0.1,0.1c1.8,1.1,30.5,19.5,19.4,47.6c-6.9,18.2-29.6,29-53.7,33.7c-5,1-9,2.1-12,3.5c-4.3,0-11.1,0.3-17.6,2.2 C123.6,151.9,115.7,157.4,115.4,168.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: -156.7439,
    cy: 555.089,
    r: 1,
    gradientTransform: "matrix(-6.8555 10.946 10.946 6.8555 -7014.1616 -1911.1615)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M142.5,195.5c-1.2-3.7-3.2-7.7-5.3-11.9c-3.7-7.4-7.4-15-7.3-21.9l0.6,0c-0.2,6.8,3.6,14.3,7.2,21.6 c2.1,4.2,4.1,8.2,5.3,12L142.5,195.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.7591,
    y1: 144.0335,
    x2: 43.0185,
    y2: 65.421,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A56A3"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196,62.2c0,0,16.3,14.2,19,27.4c2.4,11.8,3.8,34.5-27.4,43c-30,8.2-64.8,3.3-71.6,24.3c0,0-7-21.5,14.2-24.9 c21.2-3.4,50.7-6,64.3-16.4C208.2,105.2,209,78.3,196,62.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: -162.6302,
    cy: 517.7179,
    r: 1,
    gradientTransform: "matrix(23.6109 0 0 -23.6109 4002.2942 12347.6299)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.3,132c2.7-0.5,5.5-0.9,8.2-1.4l8.3-1.3c5.5-0.9,11-1.7,16.5-2.8c5.5-1,10.9-2.3,16.2-3.9l2-0.6 c0.7-0.2,1.3-0.5,2-0.7l2-0.7l1.9-0.8c2.6-1.1,5-2.5,7.3-4.1c-4.4,3.4-9.6,5.7-14.9,7.4c-5.3,1.8-10.8,3-16.2,4.1 c-5.5,1-11,1.9-16.5,2.7L130.3,132z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: -161.0419,
    cy: 547.2448,
    r: 1,
    gradientTransform: "matrix(-10.1445 16.1975 16.1975 10.1445 -10317.7959 -2771.5696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5B408"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    style: {
      stopColor: "#F3B109"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3896,
    style: {
      stopColor: "#EEA80D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5489,
    style: {
      stopColor: "#E59812"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6996,
    style: {
      stopColor: "#D98315"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    style: {
      stopColor: "#CB6817"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9822,
    style: {
      stopColor: "#BB4717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B84217"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.9,190.6c10.6,0,19.1-8.6,19.1-19.1c0-10.6-8.6-19.1-19.1-19.1s-19.1,8.6-19.1,19.1 C160.8,182,169.3,190.6,179.9,190.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1477,
    y1: 129.299,
    x2: 8.9044,
    y2: 138.3766,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.5,78.8c0,0,3.6,7.9,23.8,4.3c8.2-1.5,16.6-2,24.3-1.8c9.7,5.6,10.7,15.1,8.9,23.9 c-2.3-2.3-5.5-5.1-9.9-7.6c-9.3-5.4-25-3.1-35.6-5.2C14.5,90.4,13.5,79.2,13.5,78.8C13.5,78.8,13.5,78.8,13.5,78.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.8407,
    y1: 110.0723,
    x2: -26.3816,
    y2: 150.8974,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    style: {
      stopColor: "#1C1E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#1E2141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#232A52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#2A3D73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5BA7"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.5,78.8c0,0.4,1.1,11.6,11.5,13.6c10.6,2,26.3-0.2,35.6,5.2c4.4,2.5,7.7,5.3,9.9,7.6 c-1.4,6.6-4.3,12.7-6.4,16.5c1-12.7-7.1-15.3-22.7-16.1C21.6,104.5,8.9,99,13.5,78.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.8407,
    y1: 110.0723,
    x2: -26.3816,
    y2: 150.8974,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    style: {
      stopColor: "#F9FCFE",
      stopOpacity: 0.2444
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#E8F3FB",
      stopOpacity: 0.6141
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#CFE6F6"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.5,78.8c0,0.4,1.1,11.6,11.5,13.6c10.6,2,26.3-0.2,35.6,5.2c4.4,2.5,7.7,5.3,9.9,7.6 c-1.4,6.6-4.3,12.7-6.4,16.5c1-12.7-7.1-15.3-22.7-16.1C21.6,104.5,8.9,99,13.5,78.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.49,
    y1: 43.8187,
    x2: 39.3015,
    y2: 134.0379,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#202A4F"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M61.6,81.3c11.2,0.3,21,2.1,27,5.1c6.7,3.3,21.6,10.7,8.4,38.9C83.9,153,71.8,201.5,116.3,203 c0,0,0,0-0.1,0.1c-1.9,1.1-31.7,17.4-51.1-5.8c-12.7-14.8-11.2-39.9-3.8-63.3c1.5-4.9,2.4-8.9,2.7-12.2c2.1-3.8,5.1-9.9,6.4-16.5 C72.3,96.4,71.3,86.9,61.6,81.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: -197.592,
    cy: 530.9185,
    r: 1.0002,
    gradientTransform: "matrix(-6.3182 -11.2648 -11.2648 6.3182 4775.0459 -5485.3711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M60.4,97.8c-5.9-3.4-14.3-3.7-22.4-4c-4.7-0.2-9.2-0.4-13.1-1.1l0.1-0.5c3.8,0.7,8.3,0.9,13,1.1 c8.2,0.3,16.7,0.6,22.7,4.1L60.4,97.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.9964,
    y1: -22.8494,
    x2: 108.6665,
    y2: 195.3953,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C101F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A56A3"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M116.2,203c0,0-20.3,7.5-33.2,3.6c-11.5-3.5-32.1-13.2-24.6-44.6c7.2-30.2,28.1-58.4,13-74.5 c0,0,22.2,4.2,15,24.4c-7.2,20.3-19,47.3-16.4,64.3C72.7,193.1,95.9,206.7,116.2,203z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: -162.6149,
    cy: 517.6908,
    r: 0.9998,
    gradientTransform: "matrix(23.562 0 0 -23.562 3909.6377 12341.8447)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5D5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C101F"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M86.5,111.9c-0.9,2.6-1.8,5.3-2.7,7.9l-2.8,7.9c-1.9,5.2-3.8,10.5-5.4,15.8c-1.7,5.3-3.2,10.7-4.3,16.1 l-0.4,2c-0.1,0.7-0.2,1.4-0.3,2.1l-0.3,2.1l-0.2,2.1c-0.3,2.8-0.2,5.6,0.1,8.3c-0.9-5.5-0.3-11.2,0.7-16.7c1-5.5,2.5-10.9,4.2-16.2 c1.7-5.3,3.6-10.6,5.6-15.8L86.5,111.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: -188.6479,
    cy: 530.9109,
    r: 1,
    gradientTransform: "matrix(-9.3495 -16.6695 -16.6695 9.3495 7114.3511 -7971.9517)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB130"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5CAE30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#54A430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    style: {
      stopColor: "#479330"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    style: {
      stopColor: "#377D2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    style: {
      stopColor: "#24642A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#175226"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M28.1,155.6c10.6,0,19.1-8.6,19.1-19.1s-8.6-19.1-19.1-19.1c-10.6,0-19.1,8.6-19.1,19.1 S17.6,155.6,28.1,155.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b9ee5d79628b2f72c0fbf4016ec71f3f.svg";
export { ForwardRef as ReactComponent };